export const environment = {
    production: false,
    isStaging: true,
    apiUrl: 'https://api2.calmean.com',
    version: '1.0.0.174',
    time: '2026-10-27 09:44',
    firebase: {
        apiKey: "AIzaSyC6v2ADle7OMpe2D0s8VNeBPT7C6VzQotk",
        authDomain: "default-demo-app-825e2.firebaseapp.com",
        databaseURL: "https://default-demo-app-825e2.firebaseio.com",
        projectId: "default-demo-app-825e2",
        storageBucket: "default-demo-app-825e2.appspot.com",
        messagingSenderId: "178176288919",
        appId: "1:178176288919:web:faf807489fee36cf"
    },

};
